import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';

const OperationLeft = ({checkbox,TMA }) => {
  const options = [
    { name: "Work Order" },
    { name: "Job Card" }
  ];
  return (
    <div className="row sidebarbox m-0 d-flex flex-column"
      style={{padding: "8px", borderRadius: "5px",minHeight:"300px", maxHeight: "480px",overflowY:!checkbox.withOperations ? '' : "scroll"}}
    >
      <div className="col-12 ">
        <div className={`mb-3`}>
          <input type="checkbox" name="IsGroup" className="form-check-input" style={{backgroundColor:'#270b79',borderColor:'#270b79'}} 
          checked={checkbox.withOperations} 
          onChange={(val) => checkbox.setwithOperations(!checkbox.withOperations)}
           id="withOperations" />
          <label htmlFor="withOperations" style={{fontSize:'0.8rem',position:'relative',top:'2px',paddingLeft:'7px'}}>With Operations


            <br />
            <span style={{fontSize:'0.7rem',position:'relative',top:'-2px'}}>
              Manage cost of operations
            </span>
          </label>
        </div>
        
      </div> 
    {!checkbox.withOperations ? '' : <div className="col-12 ">
        <div className={TMA.Error ? `mb-3 errorborder` : `mb-3`}>
          <SelectSearch
            list={options}
            label="Transfer Material Against"
            getOptionLabel={(item) => item.name}
            getOptionValue={(item) => item.name}
            value={TMA.TMA}
            onChange={(val) => TMA.setTMA(val)}
          />
        </div>
      </div>}
     {!checkbox.withOperations ? '' : <div className="col-12 ">
        <div className={TMA.Error ? `mb-3 errorborder` : `mb-3`}>
          <SelectSearch
            // list={options}
            label="Routing"
            getOptionLabel={(item) => item.name}
            getOptionValue={(item) => item.name}
            // value={TMA.TMA}
            // onChange={(val) => TMA.setTMA(val)}
          />
        </div>
      </div>}
    </div>
  )
}

export default OperationLeft